import { Box, Divider, IconButton, Typography } from "@mui/material"
import { DeleteOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React from "react"
import { type FieldArrayWithId } from "react-hook-form"

import { IMAGE_MIME_TYPES_WITH_PDF } from "@/components/upload/constants"
import FileInput from "@/components/upload/FileInput"
import CertificationDateField from "@/screens/Companies/edit/components/certification/components/forms/CertificationDateField"
import CertificationLocationSelect from "@/screens/Companies/edit/components/certification/components/forms/CertificationLocationSelect"
import CertificationTypeSelect from "@/screens/Companies/edit/components/certification/components/forms/CertificationTypeSelect"
import { CERTIFICATION_ALLOWED_TYPES_LABEL } from "@/screens/Companies/edit/components/certification/constants"
import type { CompanyCertificationFormValues } from "@/screens/Companies/edit/components/certification/schema/CompanyCertificationSchema"

interface CertificationFormProps {
  companyId: string
  isUpcomingEnable: boolean
  fields: FieldArrayWithId[]
  onCertificationRemove: (index: number) => void
}

const CreateCertificationForm: FC<CertificationFormProps> = ({
  companyId,
  isUpcomingEnable,
  fields,
  onCertificationRemove,
}) => {
  return (
    <form>
      <CertificationTypeSelect name='certificationType' label='Certification Type' />
      <CertificationLocationSelect companyId={companyId} name='locationIds' label='Locations' multiple />

      {fields.map((field, index) => {
        const isUpcomingElement = index > 0
        return (
          <div key={field.id}>
            {isUpcomingElement && <Divider className='mt-6' />}

            {isUpcomingEnable && (
              <Box className='mt-6 flex items-center'>
                <Typography variant='body1' className='text-gray-700'>
                  {isUpcomingElement ? "Upcoming Certification Information" : "Certification Information"}
                </Typography>
                {isUpcomingElement && (
                  <IconButton size='small' onClick={() => onCertificationRemove(index)}>
                    <DeleteOutlined />
                  </IconButton>
                )}
              </Box>
            )}

            <Box className='flex justify-between gap-x-4'>
              <CertificationDateField name={`newCompanyCertification.${index}.effectiveDate`} label='Effective Date' />
              <CertificationDateField
                name={`newCompanyCertification.${index}.expirationDate`}
                label='Expiration Date'
              />
            </Box>

            <FileInput<CompanyCertificationFormValues>
              title='Certification Document'
              required
              name={`newCompanyCertification.${index}.image`}
              className='mt-4'
              allowedMimeTypes={IMAGE_MIME_TYPES_WITH_PDF}
              allowedTypesLabel={CERTIFICATION_ALLOWED_TYPES_LABEL}
            />
          </div>
        )
      })}
    </form>
  )
}

export default CreateCertificationForm
